const router = [
  {
    path: '/CustomEmails',
    name: 'CustomEmails',
    redirect: '/CustomEmails/list',
    component: () => import('@/modules/CustomEmails/pages'),
    children: [
      {
        path: 'list',
        name: 'emailList',
        component: () => import('@/modules/CustomEmails/pages/customEmail'),
        meta: {
          requiresAuth: true,
          requiresPermission: false,
        }
      },
      {
        path: 'edit',
        name: 'emailEdit',
        component: () => import('@/modules/CustomEmails/pages/editEmail'),
        meta: {
          requiresAuth: true,
          requiresPermission: false,
        }
      },
     
        ]
      }
    ]
export default router

